module.exports = __webpack_public_path__ + "static/media/masterCard.f4d8f5cc.svg";